import { formatTime } from "../../utils/formatters";
import { parseUtcTimestamp } from "../../services/dateTime";

const STATUS_LABELS = {
  CRITICAL: "Critical",
  HIGH: "Critical",
  MEDIUM: "Medium",
  WARNING: "Medium",
  LOW: "Low",
};

export const toAlert = (notification) => ({
  id: String(notification?.id ?? notification?.uid ?? `${notification?.batch_id}-${notification?.created_at}`),
  batchId: notification?.batch_id || "—",
  cycleId: notification?.cycle_id || notification?.parameter_id || "",
  severity: STATUS_LABELS[String(notification?.status || "LOW").toUpperCase()] || "Low",
  message: notification?.message || notification?.subject || "New production notification",
  time: notification?.created_at ? formatTime(notification.created_at)
    : parseUtcTimestamp(notification?.time) ? formatTime(notification.time) : notification?.time || "-",
  createdAt: notification?.created_at || null,
  isRead: Boolean(notification?.mark_as_read),
});

export const toAlertList = (response) => {
  const records = response?.data ?? response?.results ?? response?.items ?? [];
  return [...records]
    .sort((first, second) =>
      String(second?.created_at || "").localeCompare(String(first?.created_at || ""))
    )
    .map(toAlert);
};
